<template>
    <div>
        <div>
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">OA审批-离职申请</div>
            <el-button
                style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                @click="Return">返回</el-button>

            <!-- 主体 -->
            <div
                style="height:680px;background-color:white;margin:75px 40px 0 40px;padding:40px 60px;overflow-x: hidden">
                <!-- 查询框 -->
                <span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
                <span style="font-size:20px;font-weight:700">基本信息</span>
                <div style="border:1px solid #DADADA;margin-top:10px"></div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="姓名:" prop="name" style="margin-top:40px">
                                {{ editData.staff_name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="身份证号码:" prop="name" style="margin-top:40px">
                                {{ editData.staff_card }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="手机号:" prop="name" style="margin-top:40px">
                                {{ editData.staff_telephone }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="入职日期:" prop="name" style="margin-top:40px">
                                {{ editData.induction_time }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row style="margin-top:40px">
                        <el-col :span="18">
                            <el-form-item label="组织架构:" prop="name">
                                {{ editData.organize_name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="城市:" prop="name">
                                {{ editData.city_id }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="职位:" prop="name">
                                {{ editData.post_name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="入职薪酬:" prop="name">
                                {{ editData.induction_salary }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
                <span style="font-size:20px;font-weight:700">离职信息</span>
                <div style="border:1px solid #DADADA;margin-top:10px"></div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="离职日期:" prop="name" style="margin-top:40px">
                                {{ editData.quit_date }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="离职原因:" prop="name" style="margin-top:40px">
                                {{ editData.dictionaries }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="离职提交日期:" prop="name" style="margin-top:40px">
                                {{ editData.quit_time }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="操作人:" prop="name" style="margin-top:40px">
                                {{ editData.operator_name }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="备注:" prop="name">
                                {{ editData.remarks }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="离职审批表:" prop="name">
                                <img :src="editData.quit_url" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
                <span style="font-size:20px;font-weight:700">保险信息</span>
                <div style="border:1px solid #DADADA;margin-top:10px"></div>
                <div style="width:80%;margin:50px 10%">
                    <el-table :data="editData.dangerList" border style="width: 100%">
                        <el-table-column prop="date" label="保险类型"></el-table-column>
                        <el-table-column prop="danger_dete" label="出险时间"></el-table-column>
                        <el-table-column prop="indemnity_amount" label="赔付金额"></el-table-column>
                        <el-table-column label="理赔状态">
                            <template slot-scope="scope">
                                <img src="../../../assets/stateImg/状态_已出险.png" v-show="scope.row.state === '1'" />
                                <img src="../../../assets/stateImg/状态_未出险.png" v-show="scope.row.state === '0'" />
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div style="margin-top:20px;">
                    <span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
                    <span style="font-size:20px;font-weight:700">备注信息</span>
                    <div style="border:1px solid #DADADA;margin-top:10px"></div>
                    <el-row style="margin-top:40px">
                        <el-col :span="12">
                            <el-form-item label="备注:" prop="name">
                                <el-input placeholder="请输入备注内容" style="width: 50%; margin-left: 10px;">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                        </el-col>
                    </el-row>

                    <el-row v-show="reviewer_state == 0">
                        <el-col style="margin:50px 500px;">
                            <el-button type="goon" @click="$refs['examine'].save(id, 1)">同意</el-button>
                            <el-button type="addbtn" @click="$refs['examine'].reject(id)">驳回</el-button>
                        </el-col>
                    </el-row>
                </div>


            </div>
        </div>

        <examine ref="examine"></examine>

    </div>
</template>

<script>
import examine from "./OA_examine.vue";
export default {
    components: {
        examine: examine,
    },
    props: ["editData", "id", "reviewer_state"],
    data() {
        return {};
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        Return() {
            this.$parent.Return();
        }
    }
}
</script>

<style>
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    content: '';
}
</style>



// WEBPACK FOOTER //
// QAsp_lzsq.vue?41a0c6e2